import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import OText from 'components/CText/OText';
import Label from 'components/form/Label/Label';
import { Image } from 'components/Image/Image';

const EngagementCard = props => {
  const { sesamePlusPick, offerMetadata, offerImageLinkUrlProxy, handleClick } =
    props;

  return (
    <FlexContainer className={'pad16'} onClick={handleClick}>
      <FlexContainer className={'flex-column width100 gap-14'}>
        {sesamePlusPick && (
          <Image imgClass={'sesamePick width110px height30px'} />
        )}
        <FlexContainer className={'width100 items-align-center gap-20'}>
          <FlexContainer className={'flex-column gap-8'}>
            <img
              src={offerImageLinkUrlProxy}
              alt={offerMetadata?.name}
              className="borderRadius3 borderwhite pointer width-112px height-68px"
            />
          </FlexContainer>
          <FlexContainer className={'flex-column'}>
            <Label
              type={'Subtitle-2 system_neutral_n400_text'}
              className={'pointer'}
            >
              <OText text={offerMetadata?.name} />
            </Label>
            <Label
              type={'Subtitle-2'}
              className={'secondary_text_light pointer'}
              onClickCallback={handleClick}
              ariaLabel="View Details"
            >
              {'View details'}
            </Label>
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

const StandardEngagementOffers = props => {
  const {
    offerMetadata,
    offerImageLinkUrlProxy,
    clickDetailsHandler,
    seenPixel,
    sendPutEvenTypeFromOfferModule,
  } = props;

  const handleClick = e => {
    e.stopPropagation && e.stopPropagation();
    sendPutEvenTypeFromOfferModule();
    clickDetailsHandler(e);
  };

  const sesamePlusPick = offerMetadata?.sesamePlusPick;
  return (
    <>
      {seenPixel}
      <FlexContainer className={'flex-1 borderRightGrayN050 m-hide'}>
        <EngagementCard
          sesamePlusPick={sesamePlusPick}
          offerImageLinkUrlProxy={offerImageLinkUrlProxy}
          offerMetadata={offerMetadata}
          handleClick={handleClick}
        />
      </FlexContainer>
      <FlexContainer className={'d-hide borderBottomGrayN050'}>
        <EngagementCard
          sesamePlusPick={sesamePlusPick}
          offerImageLinkUrlProxy={offerImageLinkUrlProxy}
          offerMetadata={offerMetadata}
          handleClick={handleClick}
        />
      </FlexContainer>
    </>
  );
};

export default StandardEngagementOffers;
